/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
* Copyright 2019 Adobe
* All Rights Reserved.
*
* NOTICE: All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/

import ConfigStoreBase from "bundle/store/ConfigStore";
import { defaultPreset } from "bundle/constants/ConfigStoreConstants";
import {
    INITIAL_CONFIG, INITIAL_ACTION_CONFIG, PRESET_INITIAL_CONFIG, PRESET_FORCE_CONFIG,
    RESTRICTED_CONFIG, HIDDEN_CONFIG, RESTRICTED_ACTION_CONFIG, HIDDEN_ACTION_CONFIG, MODERN_VIEWER_CONFIG,
} from "app/constants/ConfigStoreConstants";

export default class ConfigStore extends ConfigStoreBase {
    get initialConfig() {
        return INITIAL_CONFIG;
    }

    get presetInitialConfig() {
        return PRESET_INITIAL_CONFIG;
    }

    get presetForceConfig() {
        return PRESET_FORCE_CONFIG;
    }

    get modernViewerConfig() {
        return MODERN_VIEWER_CONFIG;
    }

    init(config) {
        super.init(config);
        // Protect restricted configs
        if (this._config.noRestriction) {
            this._config = { ...RESTRICTED_CONFIG, ...this._config };
        } else {
            this._config = { ...this._config, ...RESTRICTED_CONFIG };
        }
        // No one can override hidden config
        this._config = { ...this._config, ...HIDDEN_CONFIG };
    }

    getActionConfigDiff() {
        const currentAction = "preview";
        const configs = this._generateFinalConfigObjects(currentAction, {});
        const confDiff = { ...this._actionConfig[currentAction] };
        Object.keys(confDiff).forEach(key => {
            if (confDiff[key] === configs.finalActionConfig[key]) {
                delete confDiff[key];
            }
        });

        if (!confDiff.embedMode) {
            confDiff.embedMode = defaultPreset;
        }

        const forcePresetConfig = PRESET_FORCE_CONFIG[confDiff.embedMode].actionConfig;
        Object.keys(confDiff).forEach(key => {
            if (confDiff[key] === forcePresetConfig[key]) {
                delete confDiff[key];
            }
        });

        return confDiff;
    }

    _getConfigWithRestriction(currentAction, actionConfig) {
        let finalActionConfig = { ...INITIAL_ACTION_CONFIG[currentAction], ...actionConfig };
        if (this._config.noRestriction) {
            finalActionConfig = { ...RESTRICTED_ACTION_CONFIG[currentAction], ...finalActionConfig };
        } else {
            finalActionConfig = { ...finalActionConfig, ...RESTRICTED_ACTION_CONFIG[currentAction] };
        }

        // No one can override hidden config
        finalActionConfig = { ...finalActionConfig, ...HIDDEN_ACTION_CONFIG[currentAction] };

        return finalActionConfig;
    }
}
